import React, { useEffect, useState } from "react";
import Header from "../Layout/Header/Header";
import ShopByCategory from "../LandingPage/CategorySection";
import { useDispatch } from "react-redux";
import {
  getUserDetailsAPI,
  getUserRoleAPI,
  getUserStatusAPI,
} from "../../../Store/Action/UserAction";
import { toast } from "react-toastify";

const OurBrands = () => {
  const dispatch = useDispatch();
  const [brandsData, setBrandsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        // 1. Fetch roles and status concurrently
        const [rolesResult, statusResult] = await Promise.all([
          new Promise((resolve) =>
            dispatch(getUserRoleAPI({}, (result) => resolve(result)))
          ),
          new Promise((resolve) =>
            dispatch(getUserStatusAPI({}, (result) => resolve(result)))
          ),
        ]);
        // ❌ If Role API failed
        if (!rolesResult?.status) {
          toast(rolesResult?.error?.message || "Failed to load roles");
          setIsLoading(false);
          return;
        }

        // ❌ If Status API failed
        if (!statusResult?.status) {
          toast(statusResult?.error?.message || "Failed to load status");
          setIsLoading(false);
          return;
        }
        // 2. Find "Manufacturer" role and "Approved" status
        const selectedRole = rolesResult.data.find(
          (role) => role?.user_role_name?.toLowerCase() === "manufacturer"
        );
        const selectedStatus = statusResult.data.find(
          (status) => status?.user_status_name?.toLowerCase() === "approved"
        );

        if (selectedRole && selectedStatus) {
          // 3. Fetch user details
          dispatch(
            getUserDetailsAPI(
              {
                userRoleId: selectedRole.user_role_id,
                userStatusId: selectedStatus.user_status_id,
                companyId: 1,
              },
              (result) => {
                if (result?.status) {
                  setBrandsData(result?.data || []);
                } else {
                  toast(
                    result?.error?.message ||
                      "Failed to fetch user details. Try again."
                  );
                }
                setIsLoading(false);
              }
            )
          );
        } else {
          setBrandsData([]);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        setIsLoading(false);
      }
    };

    fetchBrands();
  }, [dispatch]);

  return (
    <div className="our-brands-main-div">
      <Header />
      <ShopByCategory
        brandData={brandsData}
        fromBrands={true}
        isLoading={isLoading}
      />
    </div>
  );
};

export default OurBrands;
